import {Pagination, Table} from 'antd';
import {SorterResult} from 'antd/es/table/interface';

import {ReviewAnalysisCitiesSortKeyType} from '../../../../../../service/reivew-analysis/review-cities/review-cities-type';
import {ReviewsAndAnswersStatisticsUnitMeasurementEnum} from '../../../../../../service/reviews-and-answers-statistics/reviews-and-answers-statistics';
import {PaginationHookType} from '../../../../../../util/pagination-hook/pagination-hook-type';
import {citiesDefaultPageSize, citiesPageSizeOptions} from '../cities-page-const';
import {citiesPageColumns} from '../cities-page-helper';
import {CityTableDataType} from '../cities-page-type';

import * as styles from './cities-table.scss';

type PropsType = {
    dataSource: Array<CityTableDataType>;
    isInProgress: boolean;
    pagination: PaginationHookType;
    mainPeriod?: string;
    timeUnit: ReviewsAndAnswersStatisticsUnitMeasurementEnum;
    getSortOrder?: (columnKey: ReviewAnalysisCitiesSortKeyType) => 'ascend' | 'descend' | undefined | null;
    setSortOrder?: (sorter: SorterResult<CityTableDataType> | Array<SorterResult<CityTableDataType>>) => void;
};

export function CitiesTable(props: PropsType): JSX.Element {
    const {dataSource, isInProgress, pagination, mainPeriod, timeUnit, getSortOrder, setSortOrder} = props;

    return (
        <div className={styles.CitiesTable}>
            <Table<CityTableDataType>
                columns={citiesPageColumns({timeUnit, mainPeriod, getSortOrder})}
                dataSource={dataSource}
                key={dataSource.map((item) => item.cityName).join(', ')}
                loading={isInProgress}
                onChange={(_pagination, _filters, sorter) => {
                    setSortOrder?.(sorter);
                }}
                pagination={false}
                scroll={{x: true}}
                size="middle"
            />

            <Pagination
                align="end"
                current={pagination.page}
                defaultPageSize={citiesDefaultPageSize}
                // eslint-disable-next-line react/jsx-handler-names
                onChange={pagination.onChange}
                pageSize={pagination.pageSize}
                pageSizeOptions={citiesPageSizeOptions}
                showSizeChanger
                total={pagination.total}
            />
        </div>
    );
}
